<template>
  <a-box>
    <a-title
      size="4"
      :text="label"
    />
    <back-office-list
      class="has-word-break-all"
      :list-data="value"
      :columns="casinoColumns"
      :selectable="false"
    />
  </a-box>
</template>

<script>
  import BackOfficeList from '@/components/BackOfficeList'
  import { ATitle, ABox } from 'codefabrik-gui-vue'

  export default {
    name: 'IntegrationCasinos',
    components: { BackOfficeList, ATitle, ABox },
    props: {
      value: {
        type: Array,
        default: () => []
      },
      label: {
        type: String,
        default: ''
      },
    },
    methods: {
      loading(){
        return this.value
      }
    },
    computed: {
      casinoColumns () {
        return [
          {
            header: this.$t('common.name'),
            field: 'name',
          },
          {
            header: this.$t('casinos.id'),
            field: 'casinoId',
          },
          {
            header: this.$t('casinos.maxRTP'),
            field: 'maxRTP',
          },
          {
            header: this.$t('casinos.showDevelopStartPage'),
            field: 'options.showDevelopStartPage',
          },
          {
            header: this.$t('casinos.sendEventMessages'),
            field: 'options.sendEventMessages',
          },
        ]
      },
    },
  }
</script>

<style
  lang="scss"
  scoped
>
@import "../assets/styles";
.has-word-break-all {
  word-break: break-all;
}

</style>
